import { AsyncPipe, NgFor, NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { FormlyModule } from "@ngx-formly/core";
import { PrimeTemplate } from "primeng-v17/api";
import { PanelModule } from "primeng-v17/panel";
import { TabViewModule } from "primeng-v17/tabview";
import { TooltipModule } from "primeng-v17/tooltip";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { TabViewRememberTabDirective } from "../../shared/primeng/tab-view-remember-tab/tab-view-remember-tab.directive";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { NewUiFormlyTabsComponent } from "./new-ui-formly-tabs.component";

@Component({
  selector: "app-formly-tabs",
  templateUrl: "./formly-tabs.component.html",
  styleUrl: "./formly-tabs.component.scss",
  imports: [
    TabViewModule,
    TabViewRememberTabDirective,
    NgFor,
    NgIf,
    AsyncPipe,
    PrimeTemplate,
    TooltipModule,
    PanelModule,
    FormElementMapModule,
    TestIdDirective,
    FormlyModule,
  ],
})
export class FormlyTabsComponent extends NewUiFormlyTabsComponent {}
